import CursorLeftIcon from "../../../../../../Assets/Images/cursor-left.svg";
import ContextMenuIcon from "../../../../../../Assets/Icons/context-menu-circle.svg";
import { useNavigate } from "react-router-dom";
import { useADSContext } from "../../context/ADSProvider";
import styles from "./ADSHeader.module.scss";
import React, { useState } from "react";
import Pencil from "../../../../../../Assets/Icons/Admin panel/Pencil.svg";
import Delete from "../../../../../../Assets/Icons/Admin panel/Delete.svg";
import RenameModal from "./RenameModal";
import DeleteWeddingModal from "./DeleteWeddingModal";
import Skeleton from "@mui/material/Skeleton";

const ADSHeader = () => {
  const navigate = useNavigate();
  const { getProjectDetail, projectId, projectDetail, loadingProjectDetail } =
    useADSContext();

  const [showContextMenu, setShowContextMenu] = useState(false);
  const [showRenameModal, setShowRenameModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const navigateToAllWeddings = () => {
    navigate("/Home/My-Weddings");
  };

  const toggleContextMenu = () => {
    setShowContextMenu((prev) => !prev);
  };

  const handleShowRenameModal = () => {
    setShowRenameModal(true);
    toggleContextMenu();
  };

  const handleShowDeleteModal = () => {
    setShowDeleteModal(true);
    toggleContextMenu();
  };

  const projectName = projectDetail?.name || "My Wedding";

  return (
    <div className={styles.wrapper}>
      <section className={styles.navigate} onClick={navigateToAllWeddings}>
        <img alt="icon" src={CursorLeftIcon} />
        <p className={styles.title}>BACK TO CREATIONS</p>
      </section>

      <section className={styles.wedding}>
        {loadingProjectDetail ? (
          <Skeleton variant="rounded" width={210} height={64} />
        ) : (
          <div className={styles.weddingTrigger} onClick={toggleContextMenu}>
            <p className={styles.title}>{projectName}</p>
            <img
              alt="icon"
              src={ContextMenuIcon}
              className={styles.weddingIcon}
            />
          </div>
        )}

        {showContextMenu && (
          <>
            <div className="outline" onClick={toggleContextMenu} />

            <section className={styles.contextMenu}>
              <div
                className={styles.contextMenuRow}
                onClick={handleShowRenameModal}
              >
                <img src={Pencil} alt="icon" />
                <section>
                  <p className={styles.rowName}>Rename</p>
                  <p className={styles.rowInfo}>Rename gallery</p>
                </section>
              </div>

              <div
                className={styles.contextMenuRow}
                onClick={handleShowDeleteModal}
              >
                <img src={Delete} alt="icon" />
                <section>
                  <p className={styles.rowName}>Delete</p>
                  <p className={styles.rowInfo}>Delete gallery permanently</p>
                </section>
              </div>
            </section>
          </>
        )}

        {showRenameModal && (
          <RenameModal
            projectId={projectId}
            projectName={projectName}
            onClose={() => setShowRenameModal(false)}
            onRenameSuccess={() => {
              getProjectDetail(projectId);
              setShowRenameModal(false);
            }}
          />
        )}

        {showDeleteModal && (
          <DeleteWeddingModal
            projectId={projectId}
            close={() => setShowDeleteModal(false)}
            onDeleteSuccess={navigateToAllWeddings}
          />
        )}
      </section>
    </div>
  );
};

export default ADSHeader;
